var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3182CE",
    d: "M26 6h20v48H26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dae3ea",
    d: "M16 2h32v4H16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3182CE",
    d: "M4 6h10v46H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2c1c0",
    d: "M26 52h28v8H26z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b4d7ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 52h4v8h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 52h4v8h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 52h4v8h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 42h10v4H46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 32h10v4H46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 22h10v4H46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 12h10v4H46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 42h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 32h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 22h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 12h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 42h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 32h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 22h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 12h4v4h-4z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3182CE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 46h32v6H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 36h32v6H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26h32v6H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16h32v6H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 6h32v6H26z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b4d7ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8h12v44H14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 52h22v10H4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#dae3ea",
    d: "M2 50h24v2H2z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d6eef0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 38h12v2H14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 28h12v2H14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18h12v2H14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10h12v2H14z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M14 6h12v2H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2c1c0",
    d: "M4 52h2v10H4z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 52h1.3v10H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 52h12v1.1H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 60.9h12V62H10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 52h1.3v10h-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 52H22v10h-1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M26 58h36v2H26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dae3ea",
    d: "M24 60h38v2H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 57.8c.2-.3.3-.7.3-1.2c0-1.3-1-2.3-2.3-2.3h-.1V54c0-.6-.5-1.2-1.2-1.2c-.3 0-.5.1-.7.3c-.1-.8-.9-1.4-1.7-1.4c-1 0-1.7.8-1.7 1.8v.4c-.3-.2-.7-.4-1.1-.4c-.7 0-1.3.4-1.6 1c-.2-.1-.5-.1-.8-.1c-1.3 0-2.3 1-2.3 2.3c0 .5.2 1 .5 1.4c-.3.3-.5.7-.5 1.2c0 1 .8 1.8 1.7 1.8h9.2c.3.3.8.5 1.2.5c1.1 0 2-.9 2-2c.1-.8-.3-1.4-.9-1.8",
    fill: "#83bf4f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#699635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7 59.6c0 .6.5-.3 1.2-.3c.6 0 1.2.9 1.2.3c0-.6-.5-1.2-1.2-1.2s-1.2.6-1.2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1 57.6c0 .3.3 0 .6 0s.6.3.6 0s-.3-.6-.6-.6s-.6.2-.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 59.7c0 .3.3 0 .6 0s.6.3.6 0s-.3-.6-.6-.6c-.3.1-.6.3-.6.6"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#b5f478"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9 56c0 .3.3-.1.6-.1s.6.4.6.1c0-.3-.3-.6-.6-.6s-.6.2-.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9 57.7c0 .3.3-.1.6-.1s.6.4.6.1c0-.3-.3-.6-.6-.6c-.4 0-.6.2-.6.6"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#699635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2 56.6c0 .7.5-.4 1.2-.4s1.2 1 1.2.4s-.5-1.2-1.2-1.2s-1.2.5-1.2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1 59.3c0 .3.3 0 .6 0s.6.3.6 0s-.3-.6-.6-.6c-.3.1-.6.3-.6.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.3 54.7c0 .4.3-.2.8-.2c.4 0 .8.7.8.2c0-.4-.3-.8-.8-.8c-.4 0-.8.3-.8.8",
    fill: "#b5f478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 59.9c0 .4.3-.2.8-.2c.4 0 .8.7.8.2c0-.4-.3-.8-.8-.8s-.8.3-.8.8",
    fill: "#699635"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/work-icon.921b5a7377a39393a92611078fa0d21b.svg";
export { ForwardRef as ReactComponent };